import { inject, Injectable, Signal } from '@angular/core';
import { HeaderFooterMachCore } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  darkSiteLevel1,
  darkSiteLevel2,
  designSystemIds
} from '../../../../data-access/constants/common.constants';
import { DarkSiteConfig } from '../../../../data-access/models/interface/header/header.interfaces';
import { HeaderStateService } from './header-state.service';
import { ScreenDetectionService } from './screen-detection.service';

@Injectable({ providedIn: 'root' })
export class DarkSiteThemeService {
  private readonly screenDetection = inject(ScreenDetectionService);
  private readonly headerState = inject(HeaderStateService);

  isDarkSiteLevel(darkSiteLevel: string): boolean {
    return (
      (darkSiteLevel === darkSiteLevel1 || darkSiteLevel === darkSiteLevel2) &&
      this.screenDetection.isDesktop()
    );
  }

  applyDarkThemeStyles(): void {
    this.setDesignSystemAttribute(designSystemIds);
  }

  private setDesignSystemAttribute(ids: string[]): void {
    ids.forEach((id) => {
      const element = document.getElementById(id);
      if (element) {
        element.setAttribute('data-design-system', 'delta-mach-1-light');
      }
    });
  }

  processDarkSiteConfig(
    content: Signal<HeaderFooterMachCore | undefined>,
    onConfigUpdate: (config: DarkSiteConfig) => void
  ): void {
    const data = content();
    if (data && data.darkSite.isEnabled === 'true') {
      const config: DarkSiteConfig = {
        level: data.darkSite.level,
        theme: data.darkSite.enableBlackTheme,
        blackThemeLogo: data.logo.supergraphicDeltaMarkDarksite,
        logo: data.logo.supergraphicDeltaMark
      };

      onConfigUpdate(config);

      if (this.isDarkSiteLevel(config.level)) {
        this.headerState.selectedNav.set('');
        this.headerState.previousPrimarySelectedNav = '';
      }
    }
  }
}
